var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 40,
    viewBox: "0 0 207 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.035 20.1697C180.971 19.4629 179.799 18.9604 178.689 18.3321C177.969 17.9238 177.203 17.5624 176.578 17.0441C175.514 16.1646 175.733 14.437 176.844 13.683C178.439 12.615 181.08 13.2118 181.362 15.395C181.362 15.4421 181.409 15.4736 181.456 15.4736H183.864C183.927 15.4736 183.974 15.4264 183.958 15.3636C183.833 13.8558 183.254 12.5993 182.191 11.7982C181.174 11.0286 180.018 10.6203 178.782 10.6203C172.419 10.6203 171.84 17.3897 175.264 19.5258C175.655 19.7771 179.016 21.4733 180.206 22.2115C181.393 22.9497 181.769 24.3005 181.253 25.3685C180.783 26.3423 179.564 27.0177 178.345 26.9392C177.015 26.8606 175.984 26.1382 175.624 25.0073C175.561 24.8032 175.53 24.4104 175.53 24.2377C175.53 24.1905 175.483 24.1434 175.436 24.1434H172.826C172.779 24.1434 172.732 24.1905 172.732 24.2377C172.732 26.1382 173.201 27.1904 174.483 28.1486C175.686 29.0595 176.999 29.4365 178.361 29.4365C181.925 29.4365 183.77 27.4103 184.145 25.3057C184.473 23.2481 183.864 21.3948 182.035 20.1697Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6673 10.9659H67.5104H66.244C66.1971 10.9659 66.1658 10.9973 66.1501 11.0287L64.0083 18.128C63.977 18.2223 63.852 18.2223 63.8207 18.128L61.6787 11.0287C61.663 10.9816 61.6318 10.9659 61.5848 10.9659H60.3185H59.1615H57.598C57.5511 10.9659 57.5042 11.013 57.5042 11.0601V29.1853C57.5042 29.2324 57.5511 29.2795 57.598 29.2795H60.209C60.2559 29.2795 60.3029 29.2324 60.3029 29.1853V15.4108C60.3029 15.3008 60.4592 15.2852 60.4905 15.3794L62.648 22.5258L62.8043 23.0284C62.82 23.0755 62.8512 23.0913 62.8982 23.0913H64.8995C64.9463 23.0913 64.9776 23.0598 64.9932 23.0284L65.1496 22.5258L67.3072 15.3794C67.3385 15.2695 67.4948 15.3008 67.4948 15.4108V29.1853C67.4948 29.2324 67.5417 29.2795 67.5885 29.2795H70.1996C70.2464 29.2795 70.2934 29.2324 70.2934 29.1853V11.0601C70.2934 11.013 70.2464 10.9659 70.1996 10.9659H68.6673Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.056 10.9659C142.009 10.9659 141.978 10.9973 141.962 11.0287L139.821 18.128C139.79 18.2223 139.665 18.2223 139.633 18.128L137.491 11.0287C137.476 10.9816 137.444 10.9659 137.397 10.9659H133.426C133.379 10.9659 133.332 11.013 133.332 11.0601V29.1853C133.332 29.2324 133.379 29.2795 133.426 29.2795H136.037C136.084 29.2795 136.131 29.2324 136.131 29.1853V15.4108C136.131 15.3008 136.288 15.2852 136.319 15.3794L138.476 22.5258L138.632 23.0284C138.648 23.0755 138.679 23.0913 138.726 23.0913H140.727C140.774 23.0913 140.806 23.0598 140.821 23.0284L140.978 22.5258L143.136 15.3794C143.167 15.2695 143.323 15.3008 143.323 15.4108V29.1853C143.323 29.2324 143.37 29.2795 143.417 29.2795H146.028C146.075 29.2795 146.122 29.2324 146.122 29.1853V11.0601C146.122 11.013 146.075 10.9659 146.028 10.9659H142.056Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.379 10.9659H103.517H100.906H96.0436C95.9966 10.9659 95.9497 11.013 95.9497 11.0601V13.3218C95.9497 13.369 95.9966 13.4161 96.0436 13.4161H100.812V29.1853C100.812 29.2324 100.859 29.2795 100.906 29.2795H103.517C103.564 29.2795 103.611 29.2324 103.611 29.1853V13.4161H108.379C108.426 13.4161 108.473 13.369 108.473 13.3218V11.0601C108.473 11.013 108.442 10.9659 108.379 10.9659Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.78 29.2793H126.156C126.218 29.2793 126.265 29.2165 126.25 29.1537L121.34 10.9657C121.325 10.9186 121.294 10.9029 121.247 10.9029H120.34H118.745H117.838C117.792 10.9029 117.76 10.9343 117.745 10.9657L112.835 29.1537C112.82 29.2165 112.867 29.2793 112.929 29.2793H115.306C115.353 29.2793 115.384 29.2479 115.399 29.2165L116.822 23.9234C116.838 23.8764 116.869 23.8606 116.916 23.8606H122.17C122.217 23.8606 122.248 23.892 122.264 23.9234L123.686 29.2165C123.702 29.2479 123.749 29.2793 123.78 29.2793ZM117.541 21.2691L119.449 14.1855C119.48 14.0913 119.605 14.0913 119.636 14.1855L121.544 21.2691C121.56 21.3319 121.513 21.3947 121.45 21.3947H117.635C117.573 21.3947 117.526 21.3319 117.541 21.2691Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.305 29.2793H166.681C166.743 29.2793 166.79 29.2165 166.775 29.1537L161.866 10.9657C161.85 10.9186 161.819 10.9029 161.772 10.9029H160.865H159.271H158.363C158.316 10.9029 158.285 10.9343 158.27 10.9657L153.361 29.1537C153.345 29.2165 153.392 29.2793 153.454 29.2793H155.831C155.878 29.2793 155.91 29.2479 155.925 29.2165L157.348 23.9234C157.363 23.8764 157.395 23.8606 157.442 23.8606H162.695C162.742 23.8606 162.773 23.892 162.789 23.9234L164.211 29.2165C164.227 29.2479 164.258 29.2793 164.305 29.2793ZM158.066 21.2691L159.974 14.1855C160.005 14.0913 160.13 14.0913 160.161 14.1855L162.069 21.2691C162.085 21.3319 162.038 21.3947 161.975 21.3947H158.16C158.097 21.3947 158.051 21.3319 158.066 21.2691Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8937 26.5937V20.9708C80.8937 20.9238 80.9406 20.8766 80.9876 20.8766H87.9449C87.9919 20.8766 88.0388 20.8294 88.0388 20.7823V18.5206C88.0388 18.4736 87.9919 18.4264 87.9449 18.4264H80.9876C80.9406 18.4264 80.8937 18.3793 80.8937 18.3321V13.5261C80.8937 13.4789 80.9406 13.4318 80.9876 13.4318H88.8987C88.9456 13.4318 88.9926 13.3846 88.9926 13.3376V11.0758C88.9926 11.0287 88.9456 10.9816 88.8987 10.9816H80.8937H78.189C78.142 10.9816 78.0951 11.0287 78.0951 11.0758V13.4318V18.4421V20.8924V26.7036V29.1852C78.0951 29.2324 78.142 29.2795 78.189 29.2795H80.8937H89.227C89.2739 29.2795 89.3209 29.2324 89.3209 29.1852V26.7979C89.3209 26.7508 89.2739 26.7036 89.227 26.7036H80.9719C80.925 26.688 80.8937 26.6565 80.8937 26.5937Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.893 29.1224L196.856 19.7457C196.824 19.7143 196.824 19.6515 196.856 19.6201L204.987 11.1386C205.049 11.0758 205.002 10.9816 204.924 10.9816H201.594C201.563 10.9816 201.547 10.9973 201.531 11.013L194.637 18.2065C194.574 18.2693 194.48 18.2222 194.48 18.1436V11.0758C194.48 11.0287 194.433 10.9816 194.386 10.9816H191.775C191.728 10.9816 191.681 11.0287 191.681 11.0758V29.201C191.681 29.2481 191.728 29.2953 191.775 29.2953H194.386C194.433 29.2953 194.48 29.2481 194.48 29.201V21.2222C194.48 21.1436 194.59 21.0965 194.637 21.1593L202.453 29.2638C202.469 29.2795 202.5 29.2953 202.516 29.2953H205.846C205.908 29.2795 205.955 29.1696 205.893 29.1224Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.665 1.21213L23.8582 12.9919L26.7976 6.04969L39.665 1.21213Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20471 1.21213L18.8707 13.1018L16.0721 6.04968L3.20471 1.21213Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9735 28.5253L29.7678 34.9964L38.7734 37.4937L41.3532 28.6668L33.9735 28.5253Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53168 28.6668L4.09576 37.4937L13.0858 34.9964L8.89562 28.5253L1.53168 28.6668Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.601 17.5938L10.0995 21.3948L19.0113 21.8031L18.7142 12.1438L12.601 17.5938Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2681 17.5939L24.0612 12.0339L23.858 21.8033L32.7697 21.3949L30.2681 17.5939Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 34.9964L18.4798 32.3735L13.8364 28.7296L13.0859 34.9964Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3898 32.3735L29.768 34.9964L29.0332 28.7296L24.3898 32.3735Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.768 34.9966L24.3898 32.3737L24.8275 35.8919L24.7805 37.384L29.768 34.9966Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 34.9966L18.089 37.384L18.0577 35.8919L18.4798 32.3737L13.0859 34.9966Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1827 26.4051L13.7111 25.0858L16.8693 23.6251L18.1827 26.4051Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6868 26.4051L26.0001 23.6251L29.174 25.0858L24.6868 26.4051Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0858 34.9964L13.8675 28.5253L8.89569 28.6668L13.0858 34.9964Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0018 28.5253L29.7679 34.9964L33.9736 28.6668L29.0018 28.5253Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7697 21.3947L23.858 21.803L24.6866 26.4051L25.9999 23.625L29.1738 25.0857L32.7697 21.3947Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7111 25.0857L16.8693 23.625L18.1827 26.4051L19.0113 21.803L10.0995 21.3947L13.7111 25.0857Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 21.3947L13.8365 28.7296L13.7114 25.0857L10.0998 21.3947Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.174 25.0857L29.0333 28.7296L32.77 21.3947L29.174 25.0857Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0118 21.803L18.183 26.4051L19.2306 31.8394L19.4651 24.6773L19.0118 21.803Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8582 21.803L23.4203 24.6617L23.6393 31.8394L24.6868 26.4051L23.8582 21.803Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6868 26.4052L23.6393 31.8395L24.3898 32.3736L29.0333 28.7297L29.174 25.0858L24.6868 26.4052Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7111 25.0858L13.8363 28.7297L18.4797 32.3736L19.2302 31.8395L18.1827 26.4052L13.7111 25.0858Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7807 37.3839L24.8275 35.8918L24.4211 35.5462H18.4486L18.0577 35.8918L18.089 37.3839L13.0859 34.9965L14.837 36.4415L18.386 38.9074H24.4679L28.0326 36.4415L29.768 34.9965L24.7807 37.3839Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3897 32.3734L23.6392 31.8395H19.2302L18.4798 32.3734L18.0576 35.8918L18.4485 35.5462H24.4209L24.8275 35.8918L24.3897 32.3734Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3371 13.7615L41.6661 7.25907L39.6648 1.21213L24.3898 12.5993L30.2683 17.5938L38.5704 20.0284L40.3997 17.8766L39.6023 17.2954L40.8687 16.1332L39.8994 15.3793L41.1658 14.4055L40.3371 13.7615Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20349 7.25907L2.54808 13.7615L1.68817 14.4055L2.97021 15.3793L2.00086 16.1332L3.26727 17.2954L2.4699 17.8766L4.29916 20.0284L12.6012 17.5938L18.4798 12.5993L3.20474 1.21213L1.20349 7.25907Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5705 20.0282L30.2685 17.5938L32.77 21.3948L29.0333 28.7296L33.9739 28.6668H41.3534L38.5705 20.0282Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.601 17.5938L4.29901 20.0282L1.53168 28.6668H8.89562L13.8361 28.7296L10.0995 21.3948L12.601 17.5938Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.858 21.8032L24.3896 12.5992L26.7973 6.04967H16.072L18.4797 12.5992L19.0112 21.8032L19.2145 24.6931L19.2302 31.8395H23.6391L23.6548 24.6931L23.858 21.8032Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.092b9a3b1f6c2bf54b98405f7d8eea70.svg";
export { ForwardRef as ReactComponent };